import { render, staticRenderFns } from "./ChangelogEntry.vue?vue&type=template&id=5d8cb9ab&scoped=true"
import script from "./ChangelogEntry.vue?vue&type=script&lang=ts"
export * from "./ChangelogEntry.vue?vue&type=script&lang=ts"
import style0 from "./ChangelogEntry.vue?vue&type=style&index=0&id=5d8cb9ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8cb9ab",
  null
  
)

export default component.exports